import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Spin } from 'antd';
import { notification } from 'antd/lib';

import { APP_TERMS } from '../../../app-terms';
import { useGetCaseFile } from '../../../hooks/cases/useCaseFile';

/**
 * Opens a URL in a new browser context so the download is handled natively
 * (avoids fetching the file again as a blob in JS).
 */
const openDownloadUrl = (url) => {
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.target = '_blank';
  anchor.rel = 'noopener noreferrer';
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
};

const CaseFileDownloadLink = ({ caseId, objectKey, fileName }) => {
  const { getCaseFile } = useGetCaseFile();
  const [downloading, setDownloading] = useState(false);

  const handleClick = async (event) => {
    if (downloading) {
      return;
    }
    event?.preventDefault();
    event?.stopPropagation();

    try {
      setDownloading(true);

      const response = await getCaseFile(caseId, objectKey, fileName);
      const downloadUrl = response?.preSignedUrl;

      if (!downloadUrl) {
        throw new Error('Missing pre-signed URL');
      }

      openDownloadUrl(downloadUrl);
    } catch {
      notification.error({
        message: APP_TERMS.error_title,
        description: APP_TERMS.download_failed,
        showProgress: false,
      });
    } finally {
      setDownloading(false);
    }
  };

  return (
    <a
      className={downloading ? 'text-muted' : ''}
      onClick={handleClick}
      style={{ textWrap: 'wrap' }}
      title="Click to download"
    >
      {fileName}{' '}
      <Spin className="ms-2" spinning={downloading} />
    </a>
  );
};

CaseFileDownloadLink.displayName = 'CaseFileDownloadLink';

CaseFileDownloadLink.propTypes = {
  caseId: PropTypes.number,
  objectKey: PropTypes.string,
  fileName: PropTypes.string,
};

export default CaseFileDownloadLink;
